import { GET_NAVBAR_OPTIONS, SET_PAGE_TITLE, SET_WITH_TABS } from 'constants/ActionTypes';

export default function (state = {}, action) {
    switch (action.type) {
        case GET_NAVBAR_OPTIONS:
            return {
                ...state,
                navbarOptions: action.payload,
            };
        case SET_PAGE_TITLE:
            return {
                ...state,
                pageTitle: action.payload,
            };
        case SET_WITH_TABS:
            return {
                ...state,
                withTabs: action.payload,
            };
        default:
            return state;
    }
}
